import {Global} from "@emotion/react";
import * as React from "react";

import {Navbar} from "@atg-navigation/main-navbar";

import * as styles from "./App.styles";
import NavigationProviders from "./NavigationProviders";

function App() {
    return (
        <NavigationProviders name="NavigationApp">
            <Global styles={styles.globalStyles} />
            <Navbar />
        </NavigationProviders>
    );
}
export default App;
